export default __webpack_public_path__ + "static/media/09.42e0c76d.jpg";